
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { mapState, mapActions } from 'vuex'

export default {
name: 'app',
components: {
XHeader,
Tabbar,
TabbarItem
},
data () {
return {
title: document.title
}
},
methods: {
...mapActions([
'updateScrollPosition'
]),
goBack () {
if (this.$route.query.index === 'true' ||
window.history.length <= 1) {
this.$router.push({name: 'Home'})
} else {
this.$router.back()
}
},
callExport () {
if (this.$refs.page && this.$refs.page.export) {
this.$refs.page.export()
}
},
callNew () {
if (this.$refs.page && this.$refs.page.new) {
this.$refs.page.new()
}
},
callShare () {
if (this.$refs.page && this.$refs.page.share) {
this.$refs.page.share()
}
},
callSearch () {
if (this.$refs.page && this.$refs.page.search) {
this.$refs.page.search()
}
},
changeTitle (title) {
if (title) {
this.title = title
}
},
componentMounted (componentName) {
}
},
computed: {
...mapState({
user: state => state.oice.user,
isLoading: state => state.oice.isLoading,
direction: state => state.oice.direction,
scrollTop: state => state.oice.scrollTop
}),
leftOptions () {
return {
preventGoBack: true,
showBack: this.$route.meta.showBack
}
},
rightOptions () {
return {
showMore: this.$route.meta.showMore
}
},
headerTransition () {
return ''


},
paddingTop () {
return '46px'
},
paddingBottom () {
return '55px'
}
},
created () {
},
mounted () {
if (this.$route.meta.title) {
this.title = this.$route.meta.title
}

this.scrollHandler = () => {
let isBottom = false
let scrollBox = document.body || document.documentElement
let clientHeight = window.screen.availHeight
let scrollHeight = scrollBox.scrollHeight
let scrollTop = window.pageYOffset ? window.pageYOffset : scrollBox.scrollTop

if (scrollHeight > clientHeight) {
if (scrollTop + clientHeight >= scrollHeight - 5) {
isBottom = true
}
}

this.updateScrollPosition({path: this.$route.path, top: scrollTop, isBottom: isBottom})
}

setTimeout(() => {
let scrollBox = window
scrollBox.removeEventListener('scroll', this.scrollHandler, false)
scrollBox.addEventListener('scroll', this.scrollHandler, false)
}, 100)
},
beforeDestroy () {
window.removeEventListener('scroll', this.scrollHandler, false)
},
watch: {
$route (to, from) {
if (to.meta.title) {
this.title = to.meta.title
}
setTimeout(() => {
if (to.meta.keepAlive && this.scrollTop[to.path]) {
window.scrollTo(0, this.scrollTop[to.path])
} else {
window.scrollTo(0, 0)
}
}, 10)
},
isLoading (loading) {
if (loading) {
this.$vux.loading.show()
} else {
this.$vux.loading.hide()
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/index/App.vue